import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

// Mesmo padrão de pill ativa usado em outras abas do tema playful (ex.:
// ChallengeTab.jsx, course-tabs.jsx, ProjectsContent.jsx do aluno).
const PLAYFUL_TAB_CLASSNAME = 'data-[state=active]:-translate-y-px data-[state=active]:bg-[var(--color-mission)] data-[state=active]:font-extrabold data-[state=active]:text-white data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)]';

const TABS = [
  { label: 'Grupos', value: 'grupos', url: '/projetos/grupos' },
  { label: 'Individuais', value: 'individuais', url: '/projetos/individuais' },
  { label: 'Personalizados', value: 'personalizados', url: '/projetos/personalizados' }
];

// Substitui o TabNavBar.jsx (classes antigas .tab/.tab__link) só nas telas
// playful de Projetos — cada aba é uma rota própria, então a troca navega em
// vez de trocar conteúdo local.
export function ProjectsTabNav({ selectedTab }) {
  const navigate = useNavigate();

  const handleTabChange = value => {
    const tab = TABS.find(item => item.value === value);
    if (tab) navigate(tab.url);
  };

  return (
    <Tabs
      className="mb-6"
      value={selectedTab}
      onValueChange={handleTabChange}
    >
      <TabsList className="border border-neutral-lighter bg-white">
        {TABS.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className={PLAYFUL_TAB_CLASSNAME}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
